import $ from 'jquery';

export const init = () => {

	$(document)
		.on('click', '.inp-count__item', function(e) {
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.inp-count'),
				$inp = $closest.find('.inp-text'),
				val = Number($inp.val()) + $this.data('step');

			if (val > 0) {
				$inp.val( val );
				$inp.trigger('input');
			}
		})
		.on('change', '.inp-text', function() {
			var $this = $(this),
				val = Number($this.val());

			if (val<0) {
				$this.val(1);
				$this.trigger('input');
			}
		});

};
